import { DetailedPoliceReport } from '@/services/api/generated/policeReportsService';

import { AttestationStatusSection } from '../AttestationStatusSection';

interface PoliceDetailsInfoProps {
  report: DetailedPoliceReport;
  onUpdate: () => void;
  matterId: string;
}

const formatDate = (dateString?: string) => {
  if (!dateString) return 'No date provided';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export const PoliceDetailsInfo = ({
  report,
  onUpdate,
  matterId,
}: PoliceDetailsInfoProps) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
      {/* Status Section */}
      <AttestationStatusSection
        reportId={report.id}
        matterId={matterId}
        currentStatus={report.attestation_status as any}
        onUpdate={onUpdate}
      />

      {/* Report Details */}
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Report Identifier */}
          <div>
            <span className="block text-sm font-medium text-gray-700 mb-2">
              Report Number
            </span>
            <p className="text-sm text-gray-900 font-mono">
              {report.report_identifier || (
                <span className="text-gray-500 font-sans italic">
                  Not provided
                </span>
              )}
            </p>
          </div>

          {/* Incident Date */}
          <div>
            <span className="block text-sm font-medium text-gray-700 mb-2">
              Incident Date
            </span>
            <p className="text-sm text-gray-900">
              {report.reported_incident_date ? (
                formatDate(report.reported_incident_date)
              ) : (
                <span className="text-gray-500 italic">No date provided</span>
              )}
            </p>
          </div>

          {/* Location */}
          {report.reported_location && (
            <div className="md:col-span-2">
              <span className="block text-sm font-medium text-gray-700 mb-2">
                Incident Location
              </span>
              <p className="text-sm text-gray-900">
                {report.reported_location}
              </p>
            </div>
          )}
        </div>

        {/* Description */}
        {report.description && (
          <div className="mt-6 pt-6 border-t border-gray-100">
            <span className="block text-sm font-medium text-gray-700 mb-2">
              Description
            </span>
            <p className="text-sm text-gray-900 whitespace-pre-wrap leading-relaxed">
              {report.description}
            </p>
          </div>
        )}

        {/* Attestation Description */}
        {report.attestation_description && (
          <div className="mt-6 pt-6 border-t border-gray-100">
            <span className="block text-sm font-medium text-gray-700 mb-2">
              Status Notes
            </span>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <p className="text-sm text-blue-900 leading-relaxed">
                {report.attestation_description}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
